<div class="page-content">
  <app-navbar #navbar></app-navbar>
  <app-spinner *ngIf="isLoading"></app-spinner>
  <main [@routeAnimations]="prepareRoute(outlet)" style="position: relative;">
    <router-outlet #outlet="outlet"></router-outlet>
  </main>
</div>
